import styled, {css} from 'styled-components'

export const StyledAccessesSection = styled.div(
    () => css`
        .section-header {
            min-height: 52px;
        }
    `
)
